import { render, staticRenderFns } from "./air.vue?vue&type=template&id=5bacf6d8&"
import script from "./air.vue?vue&type=script&lang=js&"
export * from "./air.vue?vue&type=script&lang=js&"
import style0 from "./air.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports